import { mapState } from 'vuex'
import { Loading } from 'element-ui'
import { inserSeoElement } from '@/libs/utils'

const mixin = {
    name: 'Tours',
    data() {
        return {
            swiperOption: {
                spaceBetween: 30,
                effect: 'fade',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletActiveClass: 'my-bullet-active',
                    bulletClass: 'my-bullet', //需设置.my-bullet样式
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            tomorrow: new Date(),
            weekCh: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            tour_book: false,
            diaLogOptions: {},
            list: {
                select_dates: '',
                charter_time: 0,
                number_guests: 0,
            },
            values: '6AM',
            marks: {
                6: '6AM',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                // 24: '12PM',
            },
            pickerOptionsDate: {
                disabledDate: time => {
                    let yesterday = new Date()
                    yesterday.setTime(yesterday.getTime() - 24 * 60 * 60 * 1000)
                    return time.getTime() < yesterday
                },
            },
        }
    },
    created() {
        //明天的时间
        this.tomorrow.setTime(this.tomorrow.getTime() + 24 * 60 * 60 * 1000)
        this.$store.dispatch('getShareYachtsList', {
            rentDate: this.dayjs(this.tomorrow).format('YYYY-MM-DD'),
            beginTime: '6:00',
        })
    },
    mounted() {
        this.$store.dispatch('getSuperYachtsList')

        inserSeoElement(this.$t('headSeo.shareTitle'), this.$t('headSeo.shareKey'), this.$t('headSeo.shareDec'))
    },
    computed: {
        tours_lists() {
            return [
                {
                    backbg: require('@/assets/tours_daily1.png'),
                    img: require('@/assets/weather1.png'),
                    name: 'Early Risers',
                    time: '0900-1100',
                    price1: '175',
                    price2: '120',
                    detail: this.$t('tours_yacht_detail1'),
                },
                {
                    backbg: require('@/assets/afternoon.png'),
                    img: require('@/assets/weather2.png'),
                    name: 'Afternoon',
                    time: '1130-1430',
                    times: '1500-1700',
                    price1: '275',
                    price1s: '225',
                    price2: '120',
                    detail: this.$t('tours_yacht_detail2'),
                },
                {
                    backbg: require('@/assets/suns.png'),
                    img: require('@/assets/weather3.png'),
                    name: 'Sunset',
                    time: '1730-1930',
                    price1: '175',
                    price2: '120',
                    detail: this.$t('tours_yacht_detail3'),
                },
                {
                    backbg: require('@/assets/night.png'),
                    img: require('@/assets/weather4.png'),
                    name: 'Night Lights',
                    time: '2000-2200',
                    price1: '175',
                    price2: '120',
                    detail: this.$t('tours_yacht_detail4'),
                },
            ]
        },
        info_list() {
            return {
                experience: {
                    title: this.$t('yacht_tour_experience'),
                    img: [require('@/assets/tours_list1.png'), require('@/assets/tours_list3.png')],
                },
                map: {
                    title: this.$t('route_map'),
                    img: require('@/assets/video/video2.mp4'),
                },
                highlights: {
                    title: this.$t('tour_highlights'),
                    img: [require('@/assets/tours_list3.png'), require('@/assets/tours_list2.png')],
                },
                FAQ: {
                    title: this.$t('faq'),
                    map_lists: [
                        {
                            question: this.$t('tour_question1'),
                            answer: this.$t('tour_answer1'),
                        },
                        {
                            question: this.$t('tour_question2'),
                            answer: this.$t('tour_answer2'),
                        },
                        {
                            question: this.$t('tour_question3'),
                            answer: this.$t('tour_answer3'),
                        },
                        {
                            question: this.$t('tour_question4'),
                            answer: this.$t('tour_answer4'),
                        },
                        {
                            question: this.$t('tour_question5'),
                            answer: this.$t('tour_answer5'),
                        },
                        {
                            question: this.$t('tour_question6'),
                            answer: this.$t('tour_answer6'),
                        },
                        {
                            question: this.$t('tour_question7'),
                            answer: this.$t('tour_answer7'),
                        },
                        {
                            question: this.$t('tour_question8'),
                            answer: this.$t('tour_answer8'),
                        },
                        {
                            question: this.$t('tour_question9'),
                            answer: this.$t('tour_answer9'),
                        },
                        {
                            question: this.$t('tour_question10'),
                            answer: this.$t('tour_answer10'),
                        },
                    ],
                    map_question:
                        this.$t('map_question') +
                        this.$store.state.baseConfig.baseConfigInfo.serviceEmail +
                        ' / ' +
                        this.$store.state.baseConfig.baseConfigInfo.serviceMobileList[0],
                },
            }
        },
        ...mapState({
            yachtList: state => state.yachtTours.list,
        }),
        styles() {
            const length = 18,
                progress = this.list.charter_time,
                left = ((progress - 6) / length) * 100
            return {
                paddingLeft: `${left}%`,
            }
        },
        style() {
            const length = 45,
                progress = this.list.number_guests,
                left = (progress / length) * 90
            return {
                paddingLeft: `${left}%`,
            }
        },
    },
    methods: {
        close_submit() {
            this.tour_book = false
        },
        tour_submit() {
            this.tour_book = false
        },
        book(index) {
            const item = this.yachtList[index]
            const { startTime, endTime, rentDate, productId, takeOrderType, rentType, rentTimeDetailId } = item
            this.diaLogOptions = {
                startTime,
                endTime,
                rentDate,
                productId,
                takeOrderType,
                rentType,
                rentTimeDetailId,
                statusName:
                    item.timeType === 0
                        ? '清晨'
                        : item.timeType === 1
                        ? '早上'
                        : item.timeType === 2
                        ? '下午'
                        : item.timeType === 3
                        ? '傍晚'
                        : '深夜',
            }
            this.tour_book = true
        },
        reset() {},
        // 默认选择日期
        selectDate() {
            let params = {
                rentDate: this.dayjs(
                    this.list.select_dates === '' ? this.dayjs().add(1, 'day') : this.list.select_dates,
                ).format('YYYY-MM-DD'),
            }
            if (this.list.charter_time) {
                params.beginTime = this.list.charter_time + ':00'
            }
            if (this.list.number_guests) {
                params.passengerNum = this.list.number_guests
            }
            this.$store.dispatch('getShareYachtsList', params)
        },
        // 时间选择
        timeTip() {
            if (this.list.charter_time < 12) {
                this.values = this.list.charter_time + 'AM'
            } else if (this.list.charter_time == 12) {
                this.values = '12AM'
            } else if (this.list.charter_time == 24) {
                this.values = '12PM'
            } else {
                this.values = this.list.charter_time - 12 + 'PM'
            }
            // this.setLocValue({ time: this.values })
            let params = {
                rentDate: this.dayjs(
                    this.list.select_dates === '' ? this.dayjs().add(1, 'day') : this.list.select_dates,
                ).format('YYYY-MM-DD'),
            }
            params.beginTime = this.list.charter_time + ':00'
            if (this.list.number_guests) {
                params.passengerNum = this.list.number_guests
            }
            this.$store.dispatch('getShareYachtsList', params)
        },
        // 筛选人数
        async numberGuests() {
            // 筛选游艇列表
            let params = {}
            // if (!this.list.select_dates) {
            //   params["rentDate"] = this.dayjs(this.tomorrow).format("YYYY-MM-DD")
            // }
            params['rentDate'] = this.dayjs(
                this.list.select_dates === '' ? this.dayjs().add(1, 'day') : this.list.select_dates,
            ).format('YYYY-MM-DD')
            if (this.list.number_guests) {
                params['passengerNum'] = this.list.number_guests
            }
            if (this.list.charter_time) {
                params['beginTime'] = this.list.charter_time + ':00'
            }
            this.$store.dispatch('getShareYachtsList', params)
        },
    },
    watch: {
        'list.charter_time'() {
            if (this.list.charter_time < 12) {
                this.values = this.list.charter_time + 'AM'
            } else if (this.list.charter_time == 12) {
                this.values = '12AM'
            } else if (this.list.charter_time == 24) {
                this.values = '12PM'
            } else {
                this.values = this.list.charter_time - 12 + 'PM'
            }
        },
    },
}
export default mixin
